export enum StoreConsumptionStatus {
    Open = 'OPEN',
    Returned = 'RETURNED',
    Partially_Returned = 'PARTIALLY RETURNED',
}